import React from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaPrint,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaAngleRight,
} from "react-icons/fa"; // Import the necessary React Icons
import Copyright from "./Copyright";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <div
        className="container-fluid footer py-5 wow fadeIn"
        data-wow-delay="0.2s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">About Us</h4>
                <p className="mb-3">
                  Steward Cars offers top-quality car rental services across
                  Kenya. Experience comfort and reliability with every ride.
                </p>
                <div className="position-relative">
                  <input
                    className="form-control rounded-pill w-100 py-3 ps-4 pe-5"
                    type="text"
                    placeholder="Enter your email"
                  />
                  <button
                    type="button"
                    className="btn btn-secondary rounded-pill position-absolute top-0 end-0 py-2 mt-2 me-2"
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Quick Links</h4>
                <Link to="/about">
                  <FaAngleRight className="me-2" /> About
                </Link>
                <Link to="/cars">
                  <FaAngleRight className="me-2" /> Our Cars
                </Link>
                <Link to="/cars">
                  <FaAngleRight className="me-2" /> Car Types
                </Link>
                <Link to="/">
                  <FaAngleRight className="me-2" /> Our Team
                </Link>
                <Link to="/contact">
                  <FaAngleRight className="me-2" /> Contact Us
                </Link>
                <Link to="/">
                  <FaAngleRight className="me-2" /> Terms & Conditions
                </Link>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Business Hours</h4>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Monday - Friday:</h6>
                  <p className="text-white mb-0">09:00 AM to 07:00 PM</p>
                </div>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Saturday:</h6>
                  <p className="text-white mb-0">10:00 AM to 05:00 PM</p>
                </div>
                <div className="mb-3">
                  <h6 className="text-muted mb-0">Closed:</h6>
                  <p className="text-white mb-0">Sundays</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Contact Info</h4>
                <Link to="#">
                  <FaMapMarkerAlt className="me-2" /> Limuru Town, Nairobi,
                  Kenya
                </Link>
                <Link to="mailto:info@stewardcars.com">
                  <FaEnvelope className="me-2" /> stewardcars@gmail.com
                </Link>
                <Link to="tel:+254701234567">
                  <FaPhone className="me-2" /> +254 713 624 100
                </Link>
                <Link to="tel:+254701234567" className="mb-3">
                  <FaPrint className="me-2" /> +254 713 624 100
                </Link>
                <div className="d-flex">
                  <Link
                    className="btn btn-secondary btn-md-square rounded-circle me-3"
                    to="#"
                  >
                    <FaFacebookF className="text-white" />
                  </Link>
                  <Link
                    className="btn btn-secondary btn-md-square rounded-circle me-3"
                    to="#"
                  >
                    <FaXTwitter className="text-white" />
                  </Link>
                  <Link
                    className="btn btn-secondary btn-md-square rounded-circle me-3"
                    to="#"
                  >
                    <FaInstagram className="text-white" />
                  </Link>
                  <Link
                    className="btn btn-secondary btn-md-square rounded-circle me-0"
                    to="#"
                  >
                    <FaLinkedinIn className="text-white" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Copyright />
    </>
  );
};

export default Footer;
